<template>
	<div class="l-site-structure">
		<slot></slot>
	</div>
</template>

<style lang="postcss">
.l-site-structure {
	@apply flex flex-col w-full h-full;
}
:where(.l-site-structure > *) {
	@apply w-full flex-shrink-0 flex-grow-0 self-center;
}
.container {
	@apply w-full max-w-layout-max pb-[80px] mx-auto;
}
</style>
